export enum PSTFieldNames {
    PSTApproved = 'PSTApproved',
    PSTTopicCategory = 'PSTCategory',
    PSTTopicNotes = 'PSTTopicNotes',
    PSTTopicStoryOwner = 'PSTTopicOwner',
    PSTTopicStatus = 'PSTTopicStatus',
    PSTTopicType = 'PSTTopicType',
    PSTTopicEventStartDate = 'EventStart',
    PSTTopicEventEndDate = 'EventEnd',
    PSTTopicSource = 'APSource',
    PSTTags = 'Tags',
    Owner = 'Owner',
    Type = 'Type',
    PSTCreatedBy = 'CreatedBy',
    PSTExternalFiles = 'ExternalFiles',
    PSTModTime = 'ModTime',
    PSTROModTime = 'ROModTime',
    PSTTeamLocation = 'PSTTeamLocation',
    TargetPublicationDate = 'PSTTargetDate',
    Title = 'Title',
    Slug = 'Slug',
    PSTDesk = 'PSTGroup',
    Description = 'Description',

    PSTAssignmentOwner = 'PSTAssignmentOwner',
    PSTAssignmentNewsEditor = 'APNewsEditor',
    DescriptionType = 'PSTCoverageType',
    PSTAssignmentCost = 'PSTCost',
    PSTAssignmentStatus = 'PSTAssignmentStatus',
    PSTAssignmentRole = 'Editorial Team',
    PSTParentCategory = 'ParentCategory',
    PSTParentLocation = 'ParentLocation',
    PSTParentOwner = 'ParentOwner',
    PSTParentType = 'ParentType',

    UserInfoID = 'UserID',
    UserInfoProgram = 'Program',
    UserInfoGivenName = 'GivenName',
    UserInfoSurname = 'Surname',
    UserInfoEmail = 'Email',
    UserInfoSSOLogins = 'SSOLogins',
    UserInfoStatus = 'InvitationStatus',
    UserInfoRole = 'GlobalRole',
    UserInfoActive = 'Active',

    RSLocation = 'RSLocation',
    PSTTopicAddress = 'PSTTopicAddress',

    PSTViewStateType = 'PSTViewStateType',
    PSTViewStateFilter = 'PSTViewStateFilter',
    PSTViewStateGrouping = 'PSTViewStateGrouping',
    PSTViewStateSorting = 'PSTViewStateSorting',
    PSTViewStateSortOrder = 'PSTViewStateSortOrder',
    PSTViewStateGroupSortOrder = 'PSTViewStateGroupSortOrder',
    PSTViewStateLayout = 'PSTViewStateLayout',
    PSTViewStateSearchQuery = 'PSTViewStateSearchQuery',
    PSTViewStateSlideshowDelay = 'PSTViewStateSlideshowDelay',
    PSTViewStateSlideshowSequence = 'PSTViewStateSlideshowSequence',
    PSTViewStateCardCustomItems = 'PSTViewStateTopicCardCustomItems',
    PSTViewStateFeedID = 'PSTViewStateFeedID',

    PSTViewStateFeedURL = 'PSTViewStateFeedURL',
    PSTViewStateTwitterFeedNames = 'PSTViewStateTwitterFeedNames',
    PSTViewStateFeedScope = 'PSTViewStateFeedScope',
    PSTViewStateDefaultLayout = 'PSTViewStateDefaultLayout',
    PSTViewStateDefaultSort = 'PSTViewStateDefaultSort',

    PSTRichText = 'text',

    PSTWireProvider = 'WireProvider',
    PSTWirePriority = 'Priority',
    PSTWireCategory = 'WireCategory',
    PSTWirePublished = 'Published',
    PSTWireSubjectXML = 'SubjectXML',
    PSTWireImage = 'Image',
    PSTWireVideo = 'Video',
    PSTLinkedRecords = 'LinkedRecords',
    PSTWireType = 'WireType',

    PSTServerLocations = 'Locations',
    PSTRundownStartTime = 'StartTime',
    PSTRundownEndTime = 'EndTime',
    PSTRundownSequence = 'Sequence',
    PSTChannel = 'PSTChannel',
    PSTDraftText = 'Text',
    PSTStoryLocked = 'Locked',

    PSTPublicationApproved = 'PSTPublicationApproved',
    PSTPublicationTime = 'PSTPublicationListTime',
    PSTPublicationSequenceCollection = 'PublicationSequenceCollection',
    PSTPublicationListPublishedTime = 'PSTPublicationListPublishedTime',
    PSTPublicationListPublishedBy = 'PSTPublicationListPublishedBy',
    PSTPublicationListRevisionNumber = 'PSTPublicationListRevisionNumber',
    PSTPublicationStatus = 'PSTPublicationListStatus',
    PSTPublicationChannelTimeRange = 'PSTPublicationChannelTimeRange',
    PSTPublicationChannelGUID = 'PSTPublicationChannelGUID',

    PSTPublicationChannelType = 'PSTPublicationChannelType',
    PSTPublicationChannelSchedule = 'PSTPublicationChannelSchedule',
    PSTPublicationChannelSections = 'PSTPublicationChannelSections',
    PSTPublicationChannelRevisions = 'PSTPublicationChannelRevisions',
    PSTPublicationChannelActionID = 'PSTPublicationChannelActionID',
    PSTPublicationListTitle = 'PSTPublicationListTitle',
    PSTPublicationChannelEditionNames = 'PSTPublicationChannelEditionNames',
    PSTPublicationListEditionName = 'PSTPublicationEditionName',
    Relationships = 'Relationships',
    PSTViewStateGUID = 'PSTViewStateGUID',

    ContactName = 'Name',
    ContactJobTitle = 'JobTitle',
    ContactPhone = 'Phone',
    ContactWorkAddress = 'Address',
    PSTTopicOrder = 'PSTTopicOrder',
    PSTStoryOrder = 'PSTStoryOrder',
    PSTMediaPath = 'MediaPath',
    ChannelImage = 'ChannelImage',
    Creator = 'Creator',
    RoFreezePages = 'FreezePages',
    OnAir = 'OnAir',
    MosControl = 'MosControl',
    MosAir = 'MOSAir',

    TextCommands = 'TextCommands',

    ContainerTitle = 'ContainerTitle',
    EditLocked = 'EditLocked',
    EditLockedBy = 'EditLockedBy',

    DocStatus = 'DocStatus',
    Approved = 'Approved',

    // Story specific
    PSTStoryOutputType = 'PSTStoryOutputType',
    PSTStoryOwner = 'PSTStoryOwner',
    PSTStoryTopicGUID = 'PSTStoryTopicGUID',
    PSTStoryTopicTitle = 'PSTStoryTopicTitle',
    PSTStoryStatus = 'PSTStoryStatus',
    BackTimeFormatted = 'BackTimeFormatted',
    FrontTimeFormatted = 'FrontTimeFormatted',
    CumeTimeFormatted = 'CumeTimeFormatted',
    BackCumeTimeFormatted = 'BackCumeTimeFormatted',
    ReadTime = 'ReadTime',
    ModBy = 'ModBy',
    PageNum = 'PageNum',
    Break = 'Break',
    Segment = 'Segment',
    MOSStatus = 'MOSStatus',
    MOSAbstracts = 'MOSAbstracts',
    MOSIDs = 'MOSIDs',
    MOSObjSlugs = 'MOSObjSlugs',
    MOSSlugs = 'MOSSlugs',
    MOSItemDurations = 'MOSItemDurations',
    MOSTimes = 'MOSTimes',
    MOSItemTiming = 'MOSItemTiming',
    MOSSYSTEM = 'MOSSYSTEM',
    MOSChannels = 'MOSChannels',
    MOSItemEdDurations = 'MOSItemEdDurations',
    ObjectAutoCreate = 'ObjectAutoCreate',
    ObjectPlaceholderCreate = 'ObjectPlaceholderCreate',
    OriginalGUID = 'OriginalGUID',
    RowStatus = 'RowStatus',
    SegStatus = 'SegStatus',
    Actual = 'Actual',
}

export enum PSTFieldNamesEnum {
    PSTApproved = 'PSTApproved',
    PSTTopicCategory = 'PSTCategory',
    PSTTopicNotes = 'PSTTopicNotes',
    PSTTopicStoryOwner = 'PSTTopicOwner',
    PSTTopicStatus = 'PSTTopicStatus',
    PSTTopicType = 'PSTTopicType',
    PSTTopicEventStartDate = 'EventStart',
    PSTTopicEventEndDate = 'EventEnd',
    PSTTopicSource = 'APSource',
    PSTTags = 'Tags',
    Owner = 'Owner',
    Type = 'Type',
    PSTCreatedBy = 'CreatedBy',
    PSTExternalFiles = 'ExternalFiles',
    PSTModTime = 'ModTime',
    PSTROModTime = 'ROModTime',
    PSTTeamLocation = 'PSTTeamLocation',
    TargetPublicationDate = 'PSTTargetDate',
    Title = 'Title',
    Slug = 'Slug',
    PSTDesk = 'PSTGroup',
    Description = 'Description',
    PSTAssignmentOwner = 'PSTAssignmentOwner',
    PSTAssignmentNewsEditor = 'APNewsEditor',
    DescriptionType = 'PSTCoverageType',
    PSTAssignmentCost = 'PSTCost',
    PSTAssignmentStatus = 'PSTAssignmentStatus',
    PSTAssignmentRole = 'Editorial Team',
    PSTParentCategory = 'ParentCategory',
    PSTParentLocation = 'ParentLocation',
    PSTParentOwner = 'ParentOwner',
    PSTParentType = 'ParentType',
    UserInfoID = 'UserID',
    UserInfoProgram = 'Program',
    UserInfoGivenName = 'GivenName',
    UserInfoSurname = 'Surname',
    UserInfoEmail = 'Email',
    UserInfoSSOLogins = 'SSOLogins',
    UserInfoStatus = 'InvitationStatus',
    UserInfoRole = 'GlobalRole',
    UserInfoActive = 'Active',
    RSLocation = 'RSLocation',
    PSTTopicAddress = 'PSTTopicAddress',
    PSTViewStateType = 'PSTViewStateType',
    PSTViewStateFilter = 'PSTViewStateFilter',
    PSTViewStateGrouping = 'PSTViewStateGrouping',
    PSTViewStateSorting = 'PSTViewStateSorting',
    PSTViewStateSortOrder = 'PSTViewStateSortOrder',
    PSTViewStateGroupSortOrder = 'PSTViewStateGroupSortOrder',
    PSTViewStateLayout = 'PSTViewStateLayout',
    PSTViewStateSearchQuery = 'PSTViewStateSearchQuery',
    PSTViewStateSlideshowDelay = 'PSTViewStateSlideshowDelay',
    PSTViewStateSlideshowSequence = 'PSTViewStateSlideshowSequence',
    PSTViewStateCardCustomItems = 'PSTViewStateTopicCardCustomItems',
    PSTViewStateFeedID = 'PSTViewStateFeedID',
    PSTViewStateFeedURL = 'PSTViewStateFeedURL',
    PSTViewStateTwitterFeedNames = 'PSTViewStateTwitterFeedNames',
    PSTViewStateFeedScope = 'PSTViewStateFeedScope',
    PSTViewStateDefaultLayout = 'PSTViewStateDefaultLayout',
    PSTViewStateDefaultSort = 'PSTViewStateDefaultSort',
    PSTRichText = 'text',
    PSTWireProvider = 'WireProvider',
    PSTWirePriority = 'Priority',
    PSTWireCategory = 'WireCategory',
    PSTWirePublished = 'Published',
    PSTWireSubjectXML = 'SubjectXML',
    PSTWireImage = 'Image',
    PSTWireVideo = 'Video',
    PSTLinkedRecords = 'LinkedRecords',
    PSTRundownStartTime = 'StartTime',
    PSTRundownEndTime = 'EndTime',
    PSTRundownSequence = 'Sequence',
    PSTChannel = 'PSTChannel',
    PSTDraftText = 'Text',
    PSTStoryLocked = 'Locked',
    PSTPublicationApproved = 'PSTPublicationApproved',
    PSTPublicationTime = 'PSTPublicationListTime',
    PSTPublicationSequenceCollection = 'PublicationSequenceCollection',
    PSTPublicationListPublishedTime = 'PSTPublicationListPublishedTime',
    PSTPublicationListPublishedBy = 'PSTPublicationListPublishedBy',
    PSTPublicationListRevisionNumber = 'PSTPublicationListRevisionNumber',
    PSTPublicationStatus = 'PSTPublicationListStatus',
    PSTPublicationChannelTimeRange = 'PSTPublicationChannelTimeRange',
    PSTPublicationChannelGUID = 'PSTPublicationChannelGUID',
    PSTPublicationChannelType = 'PSTPublicationChannelType',
    PSTPublicationChannelSchedule = 'PSTPublicationChannelSchedule',
    PSTPublicationChannelSections = 'PSTPublicationChannelSections',
    PSTPublicationChannelRevisions = 'PSTPublicationChannelRevisions',
    PSTPublicationChannelActionID = 'PSTPublicationChannelActionID',
    PSTPublicationListTitle = 'PSTPublicationListTitle',
    PSTPublicationChannelEditionNames = 'PSTPublicationChannelEditionNames',
    PSTPublicationListEditionName = 'PSTPublicationEditionName',
    Relationships = 'Relationships',
    PSTViewStateGUID = 'PSTViewStateGUID',
    ContactName = 'Name',
    ContactJobTitle = 'JobTitle',
    ContactPhone = 'Phone',
    ContactWorkAddress = 'Address',
    PSTTopicOrder = 'PSTTopicOrder',
    PSTStoryOrder = 'PSTStoryOrder',
    PSTMediaPath = 'MediaPath',
    ChannelImage = 'ChannelImage',
    Creator = 'Creator',
    RoFreezePages = 'FreezePages',
    OnAir = 'OnAir',
    MosControl = 'MosControl',
    MosAir = 'MOSAir',
    TextCommands = 'TextCommands',
    ContainerTitle = 'ContainerTitle',
    EditLocked = 'EditLocked',
    EditLockedBy = 'EditLockedBy',
    DocStatus = 'DocStatus',
    Approved = 'Approved',
    PSTStoryOutputType = 'PSTStoryOutputType',
    PSTStoryOwner = 'PSTStoryOwner',
    PSTStoryTopicGUID = 'PSTStoryTopicGUID',
    PSTStoryTopicTitle = 'PSTStoryTopicTitle',
    PSTStoryStatus = 'PSTStoryStatus',
    BackTimeFormatted = 'BackTimeFormatted',
    FrontTimeFormatted = 'FrontTimeFormatted',
    ReadTime = 'ReadTime',
    ModBy = 'ModBy',
    PageNum = 'PageNum',
    Break = 'Break',
    Segment = 'Segment',
    MOSStatus = 'MOSStatus',
    MOSAbstracts = 'MOSAbstracts',
    MOSIDs = 'MOSIDs',
    MOSObjSlugs = 'MOSObjSlugs',
    MOSSlugs = 'MOSSlugs',
    MOSItemDurations = 'MOSItemDurations',
    MOSTimes = 'MOSTimes',
    MOSChannels = 'MOSChannels',
    MOSItemTiming = 'MOSItemTiming',
    MOSSYSTEM = 'MOSSYSTEM',
    ObjectAutoCreate = 'ObjectAutoCreate',
    ObjectPlaceholderCreate = 'ObjectPlaceholderCreate',
    OriginalGUID = 'OriginalGUID',
    RowStatus = 'RowStatus',
    SegStatus = 'SegStatus',
}
